
import React, { useEffect, useState } from "react";

import styles from "./styles.css";
import StatsCards from "./StatsCards.js";
import Chart_1 from "./Chart_1.js";
import DataTable from "./DataTable.js";
import { Divider } from 'antd';



function Content() {
  const [wholeData, setWholeData] = React.useState([]);
  const [isDataPresent, setIsDataPresent] = React.useState(false);


  useEffect(() => {
    getData()
  }, []); // <-- Have to pass in [] here!

  function getData(){
      fetch('https://data.covid19india.org/data.json')
      .then(results => results.json())
      .then(data => {
        // console.log("data : ",data["statewise"])
        setWholeData(data)
        setIsDataPresent(true)
      });
  }

  return (
    <div className="mainContent">
      {isDataPresent ? 
        (
          <div>
            <StatsCards wholeData = {wholeData}/>

            <Divider/>

            <Chart_1 wholeData = {wholeData}/>

            <Divider/>

            <DataTable wholeData = {wholeData}/>
            <br/><br/>
          </div>
        )
      : 
      <p>No API Call</p>
    }
    </div>
  );
}

export default Content;
